module.exports = __webpack_public_path__ + "static/media/Braga_stabarbara.0aee5cd2.jpg";